import { useState } from 'react';
import { Mail, Loader2 } from 'lucide-react';
import { ALLOWED_EMAIL, supabase } from '@/lib/supabase';

export default function Login() {
  const [email, setEmail] = useState(ALLOWED_EMAIL);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      if (ALLOWED_EMAIL && email.toLowerCase() !== ALLOWED_EMAIL.toLowerCase()) {
        throw new Error('Bu e-posta yetkili degil.');
      }
      const { error: err } = await supabase.auth.signInWithOtp({
        email,
        options: { emailRedirectTo: window.location.origin },
      });
      if (err) throw err;
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Beklenmeyen hata');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
      <div className="w-full max-w-sm bg-white rounded-xl shadow-sm border border-slate-200 p-6">
        <div className="flex items-center gap-2 mb-1">
          <Mail className="w-5 h-5 text-slate-700" />
          <h1 className="text-lg font-semibold text-slate-900">Siparis Takip</h1>
        </div>
        <p className="text-sm text-slate-500 mb-6">
          Magic link ile giris yapin. E-posta adresinize tek seferlik bir baglanti gonderilecek.
        </p>

        {sent ? (
          <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-lg p-3 text-sm">
            Magic link gonderildi. <strong>{email}</strong> adresinizi kontrol edin.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-3">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-slate-400"
              placeholder="ornek@ornek.com"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-800 text-white text-sm font-medium py-2 rounded-lg disabled:opacity-50"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Magic link gonder'}
            </button>
            {error && (
              <div className="bg-rose-50 border border-rose-200 text-rose-700 rounded-lg p-2 text-xs">
                {error}
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
}
